<template>
  <!--圈子首页 -->
  <div class="circle-wrapper">
    <div class="banner">
      <el-carousel trigger="click">
        <el-carousel-item v-for="item in bannerList" :key="item">
          <div class="bannerImg" :style="{backgroundImage:'url(' + item + ')', backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover'}"></div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <section>
      <div class="left mb60">
        <el-card>
          <div class="title">
            <span class="hd-title">热点内容</span>
          </div>
          <ul class="hot-content">
            <li v-for="(item,index) in hotPosts" :key="'hotPost-'+index">
                            <h1>
                                <router-link :to="{path:'/postDetail',query:{id:item.id,name:item.circleName}}">{{item.postsTitle}}</router-link>
                                <i class="iconfont" v-if="item.uploadFlag==1">&#xe645;</i>
                                <i class="icon-best" v-if="item.isEssence==1"></i>
                                 <span class="fr">来源于：
                                  <router-link :to="{path:'/postList',query:{id:item.circleId,name:item.circleName}}">{{item.circleName}}</router-link>
                                </span>
                            </h1>
                               <div class="note"  v-html="item.postsContent"></div>
                            <div class="bottom">
                                <div class="left">
                                    <img :src="$api.getPic+item.uid" alt="">
                                    <span class="name">{{item.unickname}}</span>
                                    <span class="time">{{item.createTime}}</span>
                                </div>
                                <div class="right">
                                    <span class="view">
                                        <i class="iconfont">&#xe62d;</i>{{item.viewCount}}</span>
                                    <span class="comment">
                                        <i class="iconfont">&#xe60a;</i>{{item.commentCount}}</span>
                                    <span class="laud">
                                        <i class="iconfont">&#xe60b;</i>{{item.goodCount}}</span>
                                </div>
                            </div>
                            <div class="line"></div>
                        </li>
          </ul>
         
        </el-card>
      </div>
      <div class="right">
        <el-card class="mb30">
          <div class="announcement">
            <div id="scroll-wrap" >
              <ul id="box1">
                <li v-for="(item,index) in hotMessages" :key="'message-'+index">
                  <el-tooltip :content="item.content" placement="top" effect="light" v-if="item.content.length > 16" style="width:100px!important;">
                 <a @click="toMessage(item.linkAddress,$event)"> <i class="iconfont">&#xe60f;</i>{{item.content.substring(0,16)}}...</a>
                  </el-tooltip>
                 <a v-else  @click="toMessage(item.linkAddress,$event)"> <i class="iconfont">&#xe60f;</i>{{item.content}}</a>
                </li>
              </ul>
              <ul id="box2">
              </ul>
              
            </div>
         
          </div>
        </el-card>
        <el-card class="mb30">
          <div class="title">
            <span class="hd-title">热门圈子</span>
            <router-link to="/circleList" class="all">全部&nbsp;></router-link>
          </div>
          <div class="tag-wrapper hotCircle-list">
            <div class="hotCircle-item" v-for="(item, index) in hotCircles" :key="'circle-'+index">
              <div class="title"> <router-link :to="{path:'/postList',query:{id:item.id,name:item.circleName}}">{{item.circleName}} </router-link></div>
              <div class="desc"> <router-link :to="{path:'/postList',query:{id:item.id,name:item.circleName}}">{{item.intro}}</router-link></div>
            </div>
          </div>
        </el-card>
        <el-card class="course-box mb30">
          <div class="title">
            <span class="hd-title">NLP课程</span>
            <router-link to="/nlpCourse" class="all">全部&nbsp;></router-link>
          </div>
          <div class="tag-wrapper"  style="min-height:40px;">
             <el-carousel  v-if="hotClassrooms.length>0">
        <el-carousel-item v-for="(item, index) in hotClassrooms" :key="'classrooms-'+index">
          <div class="course-item">
              <div class="img-box"><router-link :to="{path:'/courseDetail',query:{id:item.id}}"><div class="mb15 img" :style="{backgroundImage:'url('+$api.getCoursePic+'courses_cover/'+item.id+')'}"></div></router-link></div>
              <p>
                <i class="iconfont">&#xe610;</i>
                <el-tooltip  v-if="item.courseName.length > 10" :content="item.courseName" placement="top" effect="light">
                <span>{{''+item.courseName.substring(0,10)}}... </span>
              </el-tooltip>
            <span v-else>{{item.courseName}}</span>
              </p>
              <p>
                <i class="iconfont">&#xe643;</i>
                <span>
                  {{typeData[item.courseType]}}
                </span>
              </p>
              <p>
                <i class="iconfont">&#xe611;</i>
                <span>{{item.lecturer}}</span>
              </p>
            </div>
        </el-carousel-item>
      </el-carousel>
           
          </div>
        </el-card>
      </div>
    </section>
    <cFooter></cFooter>
  </div>
</template>
<script>
import {mapState, mapActions} from 'vuex';
export default {
  metaInfo: {
    title:'NLP圈子'
  },
  data() {
    return {
      bannerList: [
        '../../../static/images/nlpCircle/banner-01.jpg',
      ],
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      typeData:[],
      hotPosts: [], //热点内容
      hotCircles: [], //热门圈子
      hotClassrooms: [], //热门课程
      hotMessages: [],
    };
  },
  components: {},
  filters: {},
  beforeCreate() {},
  computed: {
    userInfo() {
      return localStorage.getItem('userInfo');
    },
  },
  created() {},
  mounted() {
    this.getHotPosts();
    this.getHotCircles();
    this.getHotClassroom();
    this.getHotMessage();
    this.getCourseType();
   
  },
  methods: {
    ...mapActions([]),
      getCourseType() {
      this.$api.getCourseType().then(res => {
        if (res.success) {
          this.typeData = res.data;
        }
      });
    },
    toMessage(linkAddress,e){
      if(linkAddress){
        e.target.setAttribute("href",linkAddress).setAttribute('target','_blank');
      }
    },
    scroll() {
      //公告滚动
      let $$ = function(id) {
        return document.getElementById(id);
      };
      let timer;
      let wrap = $$('scroll-wrap');
      $$('box2').innerHTML = $$('box1').innerHTML;
      function roll(){
        wrap.scrollTop++;
        
        if ($$('box1').offsetHeight - wrap.scrollTop > 0) {
          //尚未滚动到第二部分的顶部位置时
          if (wrap.scrollTop % wrap.offsetHeight != 0) {
            //
            return timer= setTimeout(
            roll, 20); //20毫秒即递归一次
          } else {
            //当滚动的累计距离达到显示域高度的倍数时
            return timer=setTimeout(roll, 2000); //等待2秒才递归调用
          }
        } else {
        timer= setTimeout(function() {
             $$('scroll-wrap').scrollTop = 0;
            roll();
          }, 2000);
        }
      };
     timer= setTimeout(roll, 2000);

      wrap.onmouseover = function() {
        clearTimeout(timer);
      };
      wrap.onmouseout = function() {
        timer = setTimeout(roll, 2000);
      };
    },
    getHotPosts() {
      this.$api
        .getHotPosts({}, {params: {page: this.pageNum, limit: 20}})
        .then(res => {
          if (res.success) {
            this.hotPosts = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    getHotCircles() {//热门圈子
      this.$api
        .getHotCircle({}, {params: {page: this.pageNum, limit: 5}})
        .then(res => {
          if (res.success) {
            this.hotCircles = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    getHotClassroom() {//热门课程
      this.$api
        .getHotClassroom(
          {},
          {params: {page: this.pageNum, limit: 4}}
        )
        .then(res => {
          if (res.success) {
            this.hotClassrooms = res.data;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    getHotMessage() {//消息
      this.$api
        .getHotMessage({}, {params: {page: this.pageNum, limit: 3}})
        .then(res => {
          if (res.success) {
            this.hotMessages = res.data;
            if(res.data.length > 0){
              this.$nextTick(_=>{
                 this.scroll();
              });
              
            }
          } else {
            this.$message.error(res.message);
          }
        });
    },
  },
};
</script>
<style scoped>
.note>>> p{
    color:#999!important;
}
.note>>> p>span{
    color:#999!important;
}
.note>>> p>a{
    color:#999!important;
}
.note>>> p>a>u{
    color:#999!important;
}
.note>>> p > strong{
   color:#999!important;
}
</style>
<style scoped lang="less">
@import '../../assets/less/common.less';
@import './common.less';
.note{
  color:#999!important;
  max-height:40px;
  overflow: hidden;
}
.wrapper {
  width: 1200px;
  margin: 0 auto;
}

.el-carousel__item .bannerImg {
  height: 360px;
  width: 100%;
}
#scroll-wrap {
  height: 30px;
  overflow: hidden;
  cursor: pointer;
  &:hover {
    color: @nice-blue;
  }
  li a{
    height:29px;
    line-height: 29px;
  }
}
.banner{
   /deep/ .el-carousel__arrow{
    top:50%!important;
  }
}

.course-box{
  /deep/ .el-carousel__container{
    height:370px!important;
  }
  /deep/ .el-carousel__arrow{
    top:40%!important;
  }
  /deep/ .el-carousel__arrow--left{
    left:20px!important;
  }
  /deep/ .el-carousel__arrow--right{
    right:20px!important;
  }
}
/deep/ .el-button--default {
  background-color: transparent;
  color: #fff;
}
/deep/ .el-button.is-plain:active {
  border-color: #fff;
  color: #333;
}
/deep/ .el-button.is-plain:active {
  background-color: #fff;
  color: #333;
}
/deep/ .el-button.is-plain:focus,
.el-button.is-plain:hover {
  border-color: #fff;
  color: #333;
}
.banner{
  /deep/ .el-carousel__container{
    height:360px!important;
  }
}
.hot-content {
  li {
    &:last-child {
      .line {
        border-bottom: none !important;
      }
    }
  }
}
.announcement {
  margin: 20px;
  i.iconfont {
    font-size: 16px;
    color: @nice-blue;
    margin-right: 10px;
  }
  ul {
    li {
      a {
        color: #333;
      }
      a:hover {
        color: @nice-blue;
      }
    }
  }
}
.course-item {
  width: 320px;
  margin: 20px;
  
   .img-box {
        height: 240px;
        margin-bottom: 10px;
        border-radius: 4px;
        background:#b7b7b7;
        .img {
          width: 100%;
          height: 240px;
          display: block;
          background-repeat: no-repeat;
          background-position: 50% 50%;
          background-size: cover;
             border-radius: 4px;
        }
      }
  p {
    height: 26px;
    line-height: 26px;
    i.iconfont {
      margin-right: 15px;
      color: #b9b9b9;
      font-size: 16px;
    }
  }
}
.hotCircle-list {
  padding-top:20px;
  box-sizing: border-box;
 .hotCircle-item {
   padding:0 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
    display: flex;
    .title {
      display: flex;
      line-height: 24px;
      box-sizing: border-box;
      padding: 0 10px;
      cursor: pointer;
      align-items: center;
      justify-content: center; /* 水平居中 */
      background: url('../../assets/images/nlpCircle/title-bg.png');
      width: 100px;
      height: 70px;
      border-radius: 4px;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      a {
        color: #fff !important;
      }
    }
    .desc {
      margin-left: 10px;
      display: flex;
      align-items: center;
      flex: 1;
      color: #666;
      a {
        color: #333 !important;
      }
      a:hover {
        color: @nice-blue!important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/nlpCircle/index.vue